<template>
    <div class="bg_account">
        <mainMenu/>
        <div class="container">
            <div class="width100 d-flex justify-content-center align-items-center">
                <div class="col-lg-6 ">
                    <b-card class="my-5 mx-auto " header="Изменение пароля">
                        <b-form @submit="onSubmit" class="my-5">
                            <b-form-group id="input-group-1" label="Электронная почта:" label-for="input-1">
                                <b-form-input id="input-1" v-model="form.email" type="email" placeholder="Введите email"
                                    required></b-form-input>
                            </b-form-group>
                            <b-form-group class="pt-3" id="input-group-2" label="Новый пароль:" label-for="input-2">
                                <b-form-input id="input-2" v-model="form.password" type="password"
                                    placeholder="Введите новый пароль" required></b-form-input>
                            </b-form-group>
                            <b-form-group class="pt-3" id="input-group-3" label="Подтверждение пароля:" label-for="input-3">
                                <b-form-input id="input-3" v-model="form.password2" type="password"
                                    placeholder="Введите пароль повторно" required></b-form-input>
                            </b-form-group>

                            <b-button type="submit" size="lg" variant="primary" class="mx-2 my-4">Измененить</b-button>
                            <b-button type="reset" size="lg" variant="outline-primary" class="mx-2 my-4">Очистить</b-button>
                        </b-form>
                    </b-card>
                </div>
            </div>
            <cabinetFooter />
        </div>
    </div>
</template>
<script>
import cabinetFooter from '@/components/cabinetFooter.vue'
import mainMenu from '@/components/mainMenu.vue'

export default {
    data() {
        return {
            form: {
                email: '',
                password: '',
                password2: ''
            }
        }
    },
    components: {
        cabinetFooter,
        mainMenu
    },
    mounted() {
        if (this.$route.path == '/account/save') {
            document.title = 'Изменение пароля';
        }
        if (!this.$route.params.tokenId) {
            this.$router.push({ path: `/` });
        }
    },
    methods: {
        onSubmit(event) {
            event.preventDefault()
            if (this.form.password !== this.form.password2) {
                this.$store.commit('popUpWiev', 2);
                this.$store.commit('popUpTitleWiev', 'Ошибка');
                this.$store.commit('popUpTextWiev', 'Пароли не совпадают');
            }
            else {
                this.axios.post(this.$store.getters.URL + '/account/save',
                {
                    email: this.form.email,
                    password: this.form.password,
                    password2: this.form.password2,
                    token: this.$route.params.tokenId
                })
                .then(response => (
                    this.$store.commit('reDirect', response.data.redirect),
                    this.$store.commit('popUpWiev', response.data.popUp),
                    this.$store.commit('popUpTitleWiev', response.data.title),
                    this.$store.commit('popUpTextWiev', response.data.text)
                    // this.isLogIn(response.data),
                    
                ))
                // .catch(function (error) {
                //     // console.log(error);
                // })
                ;
            }
            // alert(JSON.stringify(this.form))
        },
        onReset(event) {
            event.preventDefault()
            this.form.email = ''
        }
    }
}
</script>
<style></style>